import styled from 'styled-components'

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 3rem;
`

export const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2rem;
`

export const SideColumn = styled.div`
  width: 180px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Section = styled.section`

`

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #172b4d;
  
  svg {
    margin-right: 4px;
    color: #6b778c;
  }
`

export const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
`

export const SidebarButton = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #ebecf0;
  border: none;
  border-radius: 10px;
  padding: .9rem;
  cursor: pointer;
  text-align: left;
  color: #172b4d;
  
  svg {
    margin-right: 4px;
    color: #6b778c;
  }
  
  &:hover {
    background-color: #ebecf0;
  }
`

export const SidebarSectionTitle = styled.h4`
  font-size: 12px;
  text-transform: uppercase;
  color: #6b778c;
  font-weight: 600;
  margin: 0 0 4px 0;
  letter-spacing: 0.5px;
`

export const HistoryList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: .2rem;
  list-style: none;
  padding: .5rem 1rem 0 1rem;
`

export const HistoryItem = styled.li`
  display: flex;
  padding: 1rem;
  align-items: center;
  border-radius: 1rem;

  :hover {
    background-color: #ebecf0;
  }
`

export const UserImage = styled.div<{biggest?:boolean}>`
  width: ${props => props?.biggest ? '40px' : '18px'};
  height: ${props => props?.biggest ? '40px' : '18px'};
  border-radius: 50%;
  background-color: #0090D3;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${props => props?.biggest ? '20px' : '12px'};
  margin-right: .7rem;
`

export const HistoryItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 1rem;
  }
`

export const HistoryItemText = styled.p`
  font-size: 14px;
  color: #172b4d;

  span {
    font-weight: 700;
  }
`

export const WhatTime = styled.span`
  color: rgba(0, 0, 0, .4);
  font-size: 12px;
`

export const SimpleDataList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  padding: .5rem 1rem 0 1rem;
  list-style: none;

  svg {
    width: 14px;
    color: #6b778c;
  }
`

export const SimpleDataItem = styled.li`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #EBECF0;
  padding: .5rem;
  border-radius: 10px;
`

export const CommentList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  list-style: none;
  padding: .5rem 1rem 0 1rem;
`

export const CommentItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: .4rem;
`

export const CommentHeader = styled.div`
  display: flex;
  align-items: center;
`

export const CommentText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, .7);
  border-radius: .2rem;
`

export const InputCommentDiv = styled.div`
  display: flex;
  align-items: center;
`

export const InputComment = styled.input`
  resize: none;
  outline: none;
  border: 1px solid #dfe1e6;
  border-radius: 2rem;
  background-color: #EBEBEB;
  padding: 1rem;
  width: 100%;
  margin-top: .5rem;
  margin-bottom: .5rem;
  transition: all ease .1s;

  :focus {
    border: 1px solid #0090D3;
  }
`